import { render } from "./AddFileToDepositButton.vue?vue&type=template&id=1a1dde08"
import script from "./AddFileToDepositButton.vue?vue&type=script&lang=js"
export * from "./AddFileToDepositButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__